'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommentMessage = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../constants/messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCommentMessage = exports.isCommentMessage = (0, _curry2.default)(function (message) {
  return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, message) === _messageTypes.THREAD_COMMENT;
});